import React from 'react'

import Text from 'components/elements/Text'
import Heading from 'components/elements/Heading'
import IconButton from 'components/elements/IconButton'
import Like from 'components/Like'

// css
import 'assets/style/elements/board-header.scss'

function Element({ type, title, author, regDate, readCnt, className, showLike = false, like = 0 }) {
  return (
    <>
      <header className={'board-detail-header ' + className}>
        {type ? <Text className="f-medium f-green" text={type} /> : ''}
        <Heading className="f-noto mt4" level="1" text={title} />
        {author ? <Text className="username mt8" text={author} /> : ''}
        <div className="board-info mt8">
          <time dateTime={regDate}>{regDate}</time>
          {/* 숫자만 출력 */}
          {!isNaN(readCnt) && <span>조회 {readCnt}</span>}
        </div>
        {/* {showLike !== false && <IconButton type="like" size="40" border="true" className="border-radius-4" />} */}
        {/* {like != 0 && <Like seq={like} />} */}
        {like != 0 ? <Like seq={like} /> : ''}
      </header>
    </>
  )
}

export default Element
